import { useMutation } from 'react-query';

import { cartRepository } from '~/api/repository/cart';

/** 이쿠폰 빠른 구매(장바구니 갱신) */
// PUT /api/market-place/v2/shopping-cart-items/quick/e-coupon
export const useUpdateECouponQuick = () => {
  return useMutation({
    mutationFn: (offerId: number) => cartRepository.updateECouponQuick(offerId),
  });
};
